export const SERVICE = 'BACKOFFICE'
